var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"my-err"},[_vm._m(0),_c('div',{staticClass:"item"},[_c('label',{staticClass:"list-text"},[_vm._v(_vm._s(_vm.msg))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('label',{staticClass:"list-icon"},[_vm._v("")])])
}]

export { render, staticRenderFns }